import { render, staticRenderFns } from "./Browse.vue?vue&type=template&id=1dfb994c&scoped=true"
import script from "./Browse.vue?vue&type=script&lang=js"
export * from "./Browse.vue?vue&type=script&lang=js"
import style0 from "./Browse.vue?vue&type=style&index=0&id=1dfb994c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfb994c",
  null
  
)

export default component.exports